import React, { Fragment, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import io from "socket.io-client";
import {
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getModerators,
  moderate,
  deleteModerator,
  banUser,
  timeoutUser,
  unTimeoutUser,
  getSupporters,
  addSupporter,
} from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { getProfileById } from "../../actions/profile";
import { login, logout, getActiveUsers, clearMsg } from "../../actions/auth";
import { setAlert } from "../../actions/alert";

import CampaignChat from "../layout/Campaign/CampaignChat";
import GreenSpinner from "../../img/Green_Spinner.gif";
import CampaignModChat from "../layout/Campaign/CampaignModChat";
import RecentSupporters from "../layout/Campaign/RecentSupporters";
import StreamerVideo from "../layout/Campaign/StreamerVideo";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import Offline from "../layout/IME/Offline";
import ReportChatUser from "../layout/IME/ReportChatUser";
import BanUser from "../layout/IME/BanUser";

import TwoFARequest from "../layout/Innovators/TwoFARequest";
import Donate from "../layout/IME/Donate";
import LoggedInNav from "../layout/Campaign/LoggedInNav";
import Agreement from "../layout/IME/Agreement";
import MessageModal from "../layout/IME/MessageModal";
import MiniChat from "../layout/IME/MiniChat";
import ChatGIFModal from "../layout/IME/ChatGIFModal";
import MiniModChat from "../layout/IME/MiniModChat";
import ModChatGIFModal from "../layout/IME/ModChatGIFModal";

const ENDPOINT = "https://imelive.tv";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBILC_KEY);

let socket;

const Landing = ({
  match,
  auth: {
    user,
    channelid,
    firstname,
    lastname,
    jobtitle,
    location,
    verified,
    msg,
  },
  getGifs,
  gif: { gifs, loading },
  profile: { profile, error },
  stream: {
    chatMessages,
    modChatMessages,
    moderators,
    supporters,
    // isError,
    stream_loading,
  },
  message: { users },
  getProfileById,
  login,
  logout,
  banUser,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getGifsSearch,
  getModerators,
  getActiveUsers,
  moderate,
  deleteModerator,
  timeoutUser,
  unTimeoutUser,
  getSupporters,
  addSupporter,
  isAuthenticated,
  clearMsg,
}) => {
  const [participant, setParticipant] = useState({
    id: "",
    channelid: user.channelid,
    role: user.role,
    avatar: user.avatar,
    firstname: user.firstname,
    lastname: user.lastname,
    room: "roland",
  });
  const [showAgreement, setShowAgreement] = useState(true);
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [showDonate, setShowDonate] = useState(false);
  const [showChat, setShowChat] = useState(true);
  const [showModChat, setShowModChat] = useState(false);
  const [showMiniChat, setShowMiniChat] = useState(true);
  const [showMiniModChat, setShowMiniModChat] = useState(false);
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [userIndex, setUserIndex] = useState(-1);
  const [liveLinks, setLiveLinks] = useState([]);
  const [showGIFSearch, setShowGifs] = useState(false);
  const [showModGIFSearch, setShowModGifs] = useState(false);
  const [showGIFs, setshowGIFs] = useState(false);
  const [showModGIFs, setshowModGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [modGifSearch, setModGifSearch] = useState(false);
  const [showReportUser, setShowReportUser] = useState({
    submit: false,
    confirm: false,
  });
  const [reportedUser, setReportedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
  });
  const [showBanUser, setShowBanUser] = useState({
    submit: false,
    confirm: false,
  });
  const [bannedUser, setBannedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
    messsage: {},
    messages: [],
  });
  const [text, setText] = useState("");
  const [textValue, setTextValue] = useState("");
  const [filterText, setFilterText] = useState("");
  const [filterModText, setFilterModText] = useState("");
  const [foundGif, setGif] = useState("");
  const [foundModGif, setModGif] = useState("");
  const [message, setMessage] = useState("");
  const [modmessage, setModMessage] = useState("");
  const [donateError, setDonateError] = useState("");
  const [messages, setMessages] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [room, setRoom] = useState("roland");
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_red.png");
  const [viewerCount, setViewerCount] = useState([]);
  const [descriptionObject, setDescriptionObject] = useState({
    updatedDescription: "",
  });
  const [gifMode, setGifMode] = useState(false);
  const [isError, setIsError] = useState(false);

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    login(email, password);
  };

  const deleteMessage = (message, chatMessages) => {
    deleteChatMessage("roland", message);
    socket.emit("deleteMessage", message, chatMessages);
  };

  const deleteModMessage = (modmessage, modChatMessages) => {
    deleteModChatMessage("roland", modmessage);
    socket.emit("deletedModMessage", modmessage, modChatMessages);
  };

  const timeoutDeleteMessage = (message) => {
    deleteChatMessage("roland", message);
  };

  const banDeleteMessage = (message) => {
    deleteChatMessage("roland", message);
  };

  const timeoutDeleteModMessage = (modmessage) => {
    deleteModChatMessage("roland", modmessage);
  };

  const TimeOut = (message, profile, chatMessages) => {
    timeoutUser(message.channelid, profile.channelid);

    socket.emit("timeoutUser", message, chatMessages);

    setTimeout(() => {
      unTimeoutUser(message.channelid);
    }, 300000);
  };

  const Ban = (
    channelid,
    profile_channelid,
    text,
    isCurrent,
    description,
    video,
    image,
    gif,
    chatMessage,
  ) => {
    banUser(
      channelid,
      profile_channelid,
      text,
      isCurrent,
      description,
      video,
      image,
      gif,
      chatMessage,
    );

    socket.emit("banUser", bannedUser.message, bannedUser.messages);
  };

  const TimeOutMod = (modmessage, profile, modChatMessages) => {
    timeoutUser(modmessage.channelid, profile.channelid);

    socket.emit("timeoutModUser", modmessage, modChatMessages);

    setTimeout(() => {
      unTimeoutUser(modmessage.channelid);
    }, 300000);
  };

  const Donation = (supporter, res) => {
    if (res.data && res.data.payment.status === "succeeded") {
      addSupporter(supporter);
    }
  };

  useEffect(() => {
    getGifs();
    getProfileById("roland");
    getModerators("roland");
    setRoom("roland");
    getSupporters();
  }, [
    getGifs,
    getProfileById,
    getModerators,
    getSupporters,
    match.params.channelid,
    isAuthenticated,
    verified,
  ]);

  useEffect(() => {
    getActiveUsers(textValue);
  }, [textValue]);

  useEffect(() => {
    socket = io(ENDPOINT);

    socket.on("roomUsers", (users) => {
      setViewerCount([...users.users]);
    });

    socket.emit("getDescription", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.description,
      });
    });

    socket.on("description", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.descriptionText,
      });
    });

    socket.emit("getKeywords", (keywords) => {
      setKeywords([...keywords.keywords]);
    });

    socket.emit("getGifMode");

    socket.on("donation", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: `New Donation from ${message.channelid}!`,
        amount: message.amount,
        founding_supporter_type: message.founding_supporter_type,
        type: "notification",
      };

      chatMessages.push(messageObject);
    });

    if (isAuthenticated) {
      setParticipant({ ...participant });

      socket.on("roomUsers", (users) => {
        setViewerCount([...users.users]);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        role: user.role,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: "roland",
        type: "message",
      });
    }

    socket.on("timedOutUser", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: message.text,
        gif: "",
        room: message.room,
        deleted: false,
        timedout: true,
        founding_supporter_type: message.founding_supporter_type,
        type: "message",
      };

      chatMessages.push(messageObject);
    });

    socket.on("timedOutModUser", (modmessage) => {
      const messageObject = {
        messageid: modmessage.messageid,
        role: modmessage.role,
        channelid: modmessage.channelid,
        firstname: modmessage.firstname,
        lastname: modmessage.lastname,
        avatar: modmessage.avatar,
        text: modmessage.text,
        gif: "",
        room: modmessage.room,
        deleted: false,
        timedout: true,
        founding_supporter_type: modmessage.founding_supporter_type,
        type: "message",
      };

      modChatMessages.push(messageObject);
    });

    socket.on("bannedUser", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: message.text,
        gif: "",
        room: message.room,
        deleted: true,
        timedout: false,
        founding_supporter_type: message.founding_supporter_type,
        type: "message",
      };

      chatMessages.push(messageObject);
    });

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.disconnect();

        socket.off();

        socket.close();

        socket.on("roomUsers", (users) => {
          setViewerCount([...users.users]);
        });
      }
    };
  }, [ENDPOINT, match.params.channelid, user, chatMessages]);

  useEffect(() => {
    socket.on("welcomeMessage", (message) => {
      setMessages([...messages, message]);
    });
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("description", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.description,
      });
    });
  }, [descriptionObject.updatedDescription]);

  useEffect(() => {
    socket.on("keywords", (keywords) => {
      setKeywords([...keywords.keywords]);
    });
  }, [keywords]);

  useEffect(() => {
    socket.on("setGifMode", (currentGifMode) => {
      if (currentGifMode) {
        setGifMode(false);
      } else {
        setGifMode(true);
      }
    });
  }, [gifMode]);

  useEffect(() => {
    socket.on("message", (message) => {
      chatMessages.push(message);
    });
  }, [chatMessages]);

  useEffect(() => {
    socket.on("modmessage", (modmessage) => {
      modChatMessages.push(modmessage);
    });
  }, [modChatMessages]);

  const removeMessage = (chatMessages, message) => {
    const messageObject = {
      messageid: message.messageid,
      role: message.role,
      channelid: message.channelid,
      firstname: message.firstname,
      lastname: message.lastname,
      avatar: message.avatar,
      text: message.text,
      gif: "",
      room: message.room,
      deleted: true,
      timedout: false,
      founding_supporter_type: message.founding_supporter_type,
      type: "message",
    };

    chatMessages.filter((x) => x.messageid !== message.messageid);

    chatMessages.push(messageObject);
  };

  useEffect(() => {
    socket.on("messageDeleted", (message) => {
      removeMessage(chatMessages, message);
    });
  }, [chatMessages]);

  useEffect(() => {
    socket.on("modMessageDeleted", (modmessage) => {
      const messageObject = {
        messageid: modmessage.messageid,
        role: modmessage.role,
        channelid: modmessage.channelid,
        firstname: modmessage.firstname,
        lastname: modmessage.lastname,
        avatar: modmessage.avatar,
        text: modmessage.text,
        gif: "",
        room: modmessage.room,
        deleted: true,
        timedout: false,
        founding_supporter_type: modmessage.founding_supporter_type,
        type: "message",
      };

      chatMessages.filter((x) => x.messageid !== modmessage.messageid);

      modChatMessages.push(messageObject);
    });
  }, [modChatMessages]);

  useEffect(() => {
    socket.on("donation", (messageObject) => {
      chatMessages.push(messageObject);
    });
  }, [chatMessages]);

  useEffect(() => {
    if (liveLinks.length > 0) {
      const foundIndex = liveLinks
        .map((user) => user.channelid)
        .indexOf(participant.channelid);
      setUserIndex(foundIndex);
    }
  }, [liveLinks]);

  const sendModMessage = (e) => {
    e.preventDefault();
    if (modmessage || foundModGif !== "") {
      modChatMessage("roland", modmessage, foundModGif);
      socket.emit(
        "modChatMessage",
        modmessage,
        foundModGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room,
      );
      setModMessage("");
      setModGif("");
      setshowModGIFs(false);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || (foundGif !== "" && room !== "")) {
      chatMessage("roland", message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        { room: "roland" },
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  useEffect(() => {
    if (chatMessages.length > 20) {
      chatMessages.shift();
    }
  }, [chatMessages]);

  useEffect(() => {
    if (modChatMessages.length > 20) {
      modChatMessages.shift();
    }
  }, [modChatMessages]);

  const maxLength = 100;

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <Fragment>
      {showAgreement && !isAuthenticated && (
        <Agreement setShowAgreement={setShowAgreement} />
      )}
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          firstname={firstname}
          lastname={lastname}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {showDonate && (
        <Elements stripe={stripePromise}>
          <Donate
            profile={profile}
            setShowDonate={setShowDonate}
            showDonate={showDonate}
            users={users}
            setTextValue={setTextValue}
            Donation={Donation}
            setDonateError={setDonateError}
          />
        </Elements>
      )}
      {showBanUser.submit && (
        <BanUser
          bannedUser={bannedUser}
          setShowBanUser={setShowBanUser}
          profile_id={profile.channelid}
          Ban={Ban}
        />
      )}
      {showReportUser.submit && (
        <ReportChatUser
          reportedUser={reportedUser}
          setShowReportUser={setShowReportUser}
          profile_id={profile.channelid}
        />
      )}
      {msg && msg !== "" && (
        <MessageModal
          user={user}
          msg={
            msg !== ""
              ? msg
              : donateError !== ""
                ? donateError
                : error !== ""
                  ? error
                  : ""
          }
          clearMsg={clearMsg}
          setDonateError={setDonateError}
        />
      )}
      {donateError && donateError !== "" && (
        <MessageModal
          user={user}
          msg={
            msg !== ""
              ? msg
              : donateError !== ""
                ? donateError
                : error !== ""
                  ? error
                  : ""
          }
          clearMsg={clearMsg}
          setDonateError={setDonateError}
        />
      )}
      {showGIFSearch && (
        <ChatGIFModal
          user={user}
          profile={profile}
          message={message}
          setGif={setGif}
          foundGif={foundGif}
          showGIFSearch={showGIFSearch}
          setShowGifs={setShowGifs}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
          handleInputChange={handleInputChange}
          sendMessage={sendMessage}
          isAuthenticated={isAuthenticated}
        />
      )}
      {showModGIFSearch && (
        <ModChatGIFModal
          user={user}
          profile={profile}
          modmessage={modmessage}
          setModGif={setModGif}
          foundModGif={foundModGif}
          showModGIFSearch={showModGIFSearch}
          setShowModGifs={setShowModGifs}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
          setModMessage={setModMessage}
          sendModMessage={sendModMessage}
          isAuthenticated={isAuthenticated}
        />
      )}
      <section className="full-content">
        <LoggedInNav
          profile={profile}
          isAuthenticated={isAuthenticated}
          user={user}
          setShowDonate={setShowDonate}
          onSubmit={onSubmit}
          setprofileDropDown={setprofileDropDown}
          showMenu={showMenu}
          setShowMenu={setShowMenu}
          profileDropDown={profileDropDown}
          email={email}
          onChange={onChange}
          password={password}
          logout={logout}
        />
      </section>
      <div
        className={showChat || showModChat ? "flex-only-alt" : "flex-no-chat"}
      >
        <div className="side-container-campaign border-right grey hidden-container-campaign">
          <div className="online-recent-supporters">
            <div className="container-background">
              <div className="online-title-container-alt">
                <div className="border-alt red">
                  <p className="online-title-alt red">
                    <i className="fa-solid fa-medal red mr-5"></i>Recent
                    Supporters
                  </p>
                </div>
              </div>
              {supporters && supporters.length > 0 ? (
                supporters.map((supporter) => {
                  return (
                    <RecentSupporters
                      key={supporter._id}
                      supporter={supporter}
                    />
                  );
                })
              ) : (
                <div className="empty-side-container">
                  <p className="empty-content-alt-dark-chat red bold">
                    No Recent Supporters
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="main-stream-content">
          <div className="video-chat">
            {/* {!isError ? (
              <StreamerVideo
                profile={profile}
                showChat={showChat}
                descriptionObject={descriptionObject}
                viewerCount={viewerCount}
                setIsError={setIsError}
              />
            ) : (
              // : !isError && stream_loading ? (
              //   <div className="profile-error">
              //     <img src={GreenSpinner} alt="green-spinner" />
              //   </div>
              // )
              isError && (
                <Offline
                  profile={profile}
                  showChat={showChat}
                  viewerCount={viewerCount}
                />
              )
            )} */}
            <StreamerVideo
              profile={profile}
              showChat={showChat}
              descriptionObject={descriptionObject}
              viewerCount={viewerCount}
              setIsError={setIsError}
            />
            {!showChat && !showModChat && (
              <div
                className="showchaticon hidden-container"
                onClick={() => setShowChat(true)}
              >
                <i className="far fa-comment fa-2x red"></i>
              </div>
            )}
          </div>
          <div className="stream-keywords">
            <ul>
              {keywords.length > 0 &&
                keywords.map((keyword, index) => {
                  return (
                    <li className="stream-text-keywords red" key={index}>
                      {keyword}
                    </li>
                  );
                })}
            </ul>
          </div>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                    className="streamer-user-avi"
                  />
                  <div className="helper-container">
                    {descriptionObject.updatedDescription !== "" &&
                      descriptionObject.updatedDescription !== undefined && (
                        <p className="stream-description">
                          {descriptionObject.updatedDescription}
                        </p>
                      )}
                    <div className="stream-lower-info">
                      <ul className="creator-stream-items">
                        <li className="stream-item red bold">
                          {profile.channelid}
                        </li>
                        <li className="stream-item">{profile.firstname}</li>
                        <li className="stream-item">{profile.jobtitle}</li>
                        <li className="stream-item">ime.live.mail@gmail.com</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container">
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <div className="hidden-container">
            <div className="grid-rows-support">
              <div className="support-type-container grey">
                <p className="support-type green bold">
                  <span className="support-title">Overwhelming Support</span>{" "}
                  <i className="fa-solid fa-plus green"></i>{" "}
                  <span className="white mr-2">$</span>
                  <span className="white">300</span>
                  <i className="fa-solid fa-angles-up green mx-5"></i>
                </p>
                <div className="ime-description">
                  <ul>
                    <li>
                      <span className="green bold">Live Chat Access - </span>{" "}
                      Text access to the online live chat.
                    </li>
                    <li>
                      <span className="green bold">Community Posts - </span>{" "}
                      Create and share posts in the ime Community Posts page.
                    </li>
                    <li>
                      <span className="green bold">GIFs - </span>
                      Ability to use GIFs within the live chat and Community
                      Posts.
                    </li>
                    <li>
                      <span className="green bold">"Star" Badge - </span>
                      Special "star" badge unlocked and displayed next to user's
                      name whenever user creates a message in the live chat.
                    </li>
                    <li>
                      <span className="green bold">"1" Badge - </span>
                      Special badge indicated by the number "1" unlocked and
                      displayed next to user's name whenever user creates a
                      message in the live chat. This badge signifies users that
                      are founding supporters.
                    </li>
                    <li>
                      <span className="green bold">
                        Animated Spinning "ime" Logo in Live Chat -{" "}
                      </span>
                      User's name will have a special "ime" logo animation
                      beside their name whenever user creates a message in the
                      live chat.
                    </li>
                    <li>
                      <span className="green bold">
                        Animated Name in Live Chat -{" "}
                      </span>
                      User's name will have a special animation beside their
                      name whenever user creates a message in the live chat.
                    </li>
                    <li>
                      <span className="green bold">ime Discord Access - </span>
                      Access to ime's Discord. Fun Live Discussion participation
                      and Live Link sessions will be held within Disocrd until
                      full functionality is available within the site.
                    </li>
                    <li>
                      <span className="red bold">
                        *IMPORTANT DISCLAIMER: Donations accumulate as long as
                        the email address used for previous dontation(s) is an
                        EXACT match each time you donate. If you are currently
                        logged in while making a donation, it will be applied to
                        the email address associated with the current logged in
                        account. These benefits are VOIDED if user is not in
                        compliance with the ime Terms of Agreement and Community
                        Guidelines.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="support-type-container grey">
                <p className="support-type green bold">
                  <span className="support-title">Great Support</span>{" "}
                  <span className="white mr-2">$</span>
                  <span className="white">100</span>
                  <i className="fa-solid fa-minus green mx-10"></i>
                  <span className="white mr-2">$</span>
                  <span className="white">299</span>
                </p>
                <div className="ime-description">
                  <ul>
                    <li>
                      <span className="green bold">Live Chat Access - </span>{" "}
                      Text access to the online live chat.
                    </li>
                    <li>
                      <span className="green bold">Community Posts - </span>{" "}
                      Create and share posts in the ime Community Posts page.
                    </li>
                    <li>
                      <span className="green bold">GIFs - </span>
                      Ability to use GIFs within the live chat and Community
                      Posts.
                    </li>
                    <li>
                      <span className="green bold">"1" Badge - </span>
                      Special badge indicated by the number "1" unlocked and
                      displayed next to user's name whenever user creates a
                      message in the live chat. This badge signifies users that
                      are founding supporters.
                    </li>
                    <li>
                      <span className="green bold">ime Discord Access - </span>
                      Access to ime's Discord. Fun Live Discussion participation
                      and Live Link sessions will be held within Disocrd until
                      full functionality is available within the site.
                    </li>
                    <li>
                      <span className="red bold">
                        *IMPORTANT DISCLAIMER: Donations accumulate as long as
                        the email address used for previous dontation(s) is an
                        EXACT match each time you donate. If you are currently
                        logged in while making a donation, it will be applied to
                        the email address associated with the current logged in
                        account. These benefits are VOIDED if user is not in
                        compliance with the ime Terms of Agreement and Community
                        Guidelines.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="support-type-container grey">
                <p className="support-type green bold">
                  <span className="support-title">Good Support</span>{" "}
                  <span className="white mr-2">$</span>
                  <span className="white">20</span>
                  <i className="fa-solid fa-minus green mx-10"></i>
                  <span className="white mr-2">$</span>
                  <span className="white">99</span>
                </p>
                <div className="ime-description">
                  <ul>
                    <li>
                      <span className="green bold">Live Chat Access - </span>{" "}
                      Text access to the online live chat.
                    </li>
                    <li>
                      <span className="green bold">Community Posts - </span>{" "}
                      Create and share posts in the ime Community Posts page.
                    </li>
                    <li>
                      <span className="green bold">"1" Badge - </span>
                      Special badge indicated by the number "1" unlocked and
                      displayed next to user's name whenever user creates a
                      message in the live chat. This badge signifies users that
                      are founding supporters.
                    </li>
                    <li>
                      <span className="green bold">ime Discord Access - </span>
                      Access to ime's Discord. Fun Live Discussion participation
                      and Live Link sessions will be held within Disocrd until
                      full functionality is available within the site.
                    </li>
                    <li>
                      <span className="red bold">
                        *IMPORTANT DISCLAIMER: Donations accumulate as long as
                        the email address used for previous dontation(s) is an
                        EXACT match each time you donate. If you are currently
                        logged in while making a donation, it will be applied to
                        the email address associated with the current logged in
                        account. These benefits are VOIDED if user is not in
                        compliance with the ime Terms of Agreement and Community
                        Guidelines.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="grid-rows-alt">
              <p className="section-name-home white">
                What is ime <i className="fa-solid fa-question fa-lg green"></i>
              </p>
              <p className="ime-description">
                ime is a place where Innovators, Mentors and Employers come
                together to intellectually network, share creative ideas, unlock
                their innovative attributes and collaborate in effort to satisfy
                their psychological and professional needs. As the world we live
                in constantly changes, so does the way we interact with one
                another. That being said, ime's biggest goal is to provide a
                platform for individuals to share their greatest ideas, give
                back the knowledge and experiences they have for themselves,
                along with providing opportunities for those eager to take
                advantage. Think of ime as a place of constant beneficial
                flowing knowledge and opportunity.
              </p>
            </div>
            <div className="grid-rows-alt">
              <p className="section-border"></p>
              <p className="section-name-home white">
                Live Streaming{" "}
                <i className="fa-solid fa-tower-broadcast fa-lg green mx-5"></i>
              </p>
              <p className="ime-description">
                3..2..1.. and we are live! Live streaming has become a very
                common method of communicating with one another (especially
                since the 2020 pandemic). ime provides a platform for
                Innovators, Mentors and Employers to utilize live streaming.
                With Live Discussions, Innovators are on a time limit in which
                each participating individual gets a slotted amount of time to
                share their knowledge on the topic at hand. Spectators can
                up-vote the participating Innovator they most relate with in the
                discussion. Mentors are a vital asset for live streaming on ime.
                Sharing knowledge and/or experiences they have for themselves is
                a way to help Innovators discover or further improve on the many
                great opportunities that life has to offer. Get as creative as
                you'd like while providing knowledge and mentorship to those in
                search, or LiveLink with actively subscribed individuals within
                your community.
                <br />
                <br />
                Lastly, Employers are also apart of the live streaming
                experience on ime. Once an Employer posts an open position, they
                can go live and have open conversations with those interested.
                Ice breaker questions, qualifying questions and more can help
                Employers identify the right Innovators ahead of schedule.
              </p>
            </div>
            <div className="grid-rows-alt">
              <p className="section-border"></p>
              <p className="section-name-home white">
                Industry of the Week and Employer Spotlight
                <i className="fa-solid fa-ranking-star fa-lg green mx-10"></i>
              </p>
              <p className="ime-description">
                Each week, ime will aim to highlight an industry and take a deep
                dive into the many different fun facts, experiences and industry
                leaders within said industry. Think of it as a documentary-like
                series where each episode takes a deep dive and places on
                display a Discovery-channel-like experience. Same goes for the
                Employer Spotlight. We hope to work with Employers and spotlight
                things such as their rich history, success stories, career
                opportunities, record breaking accolades and more! Both the
                Industry of the Week and Employer Spotlight pages will also
                provide a live chat where individuals can discuss the mentioned
                Industry or Employer. The vision is to bring in-depth and
                exclusive content that can only be found on ime.
              </p>
            </div>
            <div className="grid-rows-alt">
              <p className="section-border"></p>
              <p className="section-name-home white">
                And much more...!
                <i className="fa-solid fa-heart-circle-plus fa-lg green mx-10"></i>
              </p>
              <p className="ime-description">
                There is so much more that is envisioned for ime. Wish to write
                an inspirational article? ime can help in effort for you to do
                so. Simply want to quick apply for a job? ime provides that
                ability as well. While ime has many hopes, ideas and ambitions
                for the platform, ultimately it will be transformed into its
                greater self with the influence of its users. If you have read
                about what ime plans to offer to this point, thank you for being
                inspired for something great! Providing financial support helps
                the development process continue towards a full launch, as well
                as grants you access to chat in the live chat during livestream
                sessions. Thanks again!
              </p>
            </div>
          </div>
          {showMiniChat && (
            <div className="mini-chat-container">
              <MiniChat
                user={user}
                profile={profile}
                chatMessages={chatMessages}
                messages={messages}
                message={message}
                deleteMessage={deleteMessage}
                timeoutDeleteMessage={timeoutDeleteMessage}
                gifs={gifs}
                setGif={setGif}
                foundGif={foundGif}
                showGIFSearch={showGIFSearch}
                setShowGifs={setShowGifs}
                gifSearch={gifSearch}
                setGifSearch={setGifSearch}
                sendMessage={sendMessage}
                text={text}
                setText={setText}
                setShowMiniChat={setShowMiniChat}
                setShowMiniModChat={setShowMiniModChat}
                handleInputChange={handleInputChange}
                maxLength={maxLength}
                filterText={filterText}
                setFilterText={setFilterText}
                setShowReportUser={setShowReportUser}
                setReportedUser={setReportedUser}
                setShowBanUser={setShowBanUser}
                setBannedUser={setBannedUser}
                moderators={moderators}
                moderate={moderate}
                deleteModerator={deleteModerator}
                TimeOut={TimeOut}
                banDeleteMessage={banDeleteMessage}
                Ban={Ban}
                viewerCount={viewerCount}
                setMessage={setMessage}
                gifMode={gifMode}
              />
            </div>
          )}
          {showMiniModChat && (
            <MiniModChat
              user={user}
              profile={profile}
              modChatMessages={modChatMessages}
              modmessage={modmessage}
              setModMessage={setModMessage}
              deleteModMessage={deleteModMessage}
              TimeOutMod={TimeOutMod}
              gifs={gifs}
              setModGif={setModGif}
              foundModGif={foundModGif}
              showModGIFs={showModGIFs}
              setShowModGifs={setShowModGifs}
              showModGIFSearch={showModGIFSearch}
              setModGifSearch={setModGifSearch}
              sendModMessage={sendModMessage}
              text={text}
              maxLength={maxLength}
              setFilterModText={setFilterModText}
              filterModText={filterModText}
              setShowMiniModChat={setShowMiniModChat}
              setShowMiniChat={setShowMiniChat}
              setShowReportUser={setShowReportUser}
              setReportedUser={setReportedUser}
              moderators={moderators}
              deleteModerator={deleteModerator}
              TimeOut={TimeOut}
              timeoutDeleteModMessage={timeoutDeleteModMessage}
              setMessage={setMessage}
            />
          )}
        </div>
        {showModChat && !showChat && user.channelid === "roland" && (
          <CampaignModChat
            user={user}
            profile={profile}
            modChatMessages={modChatMessages}
            modmessage={modmessage}
            setModMessage={setModMessage}
            deleteModMessage={deleteModMessage}
            TimeOutMod={TimeOutMod}
            gifs={gifs}
            setModGif={setModGif}
            foundModGif={foundModGif}
            showModGIFs={showModGIFs}
            setshowModGIFs={setshowModGIFs}
            modGifSearch={modGifSearch}
            setModGifSearch={setModGifSearch}
            sendModMessage={sendModMessage}
            text={text}
            setFilterModText={setFilterModText}
            filterModText={filterModText}
            setShowModChat={setShowModChat}
            setShowChat={setShowChat}
            setShowReportUser={setShowReportUser}
            setReportedUser={setReportedUser}
            moderators={moderators}
            deleteModerator={deleteModerator}
            TimeOut={TimeOut}
            timeoutDeleteModMessage={timeoutDeleteModMessage}
            setMessage={setMessage}
            viewerCount={viewerCount}
            maxLength={maxLength}
          />
        )}
        {showModChat &&
          !showChat &&
          moderators &&
          moderators.length > 0 &&
          moderators.map((mod) => {
            if (user.channelid === mod.channelid) {
              return (
                <CampaignModChat
                  user={user}
                  profile={profile}
                  modChatMessages={modChatMessages}
                  modmessage={modmessage}
                  setModMessage={setModMessage}
                  deleteModMessage={deleteModMessage}
                  TimeOutMod={TimeOutMod}
                  gifs={gifs}
                  setModGif={setModGif}
                  foundModGif={foundModGif}
                  showModGIFs={showModGIFs}
                  setshowModGIFs={setshowModGIFs}
                  modGifSearch={modGifSearch}
                  setModGifSearch={setModGifSearch}
                  sendModMessage={sendModMessage}
                  text={text}
                  setFilterModText={setFilterModText}
                  filterModText={filterModText}
                  setShowModChat={setShowModChat}
                  setShowChat={setShowChat}
                  setShowReportUser={setShowReportUser}
                  setReportedUser={setReportedUser}
                  setShowBanUser={setShowBanUser}
                  setBannedUser={setBannedUser}
                  moderators={moderators}
                  deleteModerator={deleteModerator}
                  TimeOut={TimeOut}
                  timeoutDeleteModMessage={timeoutDeleteModMessage}
                  banDeleteMessage={banDeleteMessage}
                  Ban={Ban}
                  viewerCount={viewerCount}
                  setMessage={setMessage}
                  maxLength={maxLength}
                />
              );
            }
          })}
        {showChat && !showModChat && (
          <CampaignChat
            user={user}
            profile={profile}
            chatMessages={chatMessages}
            messages={messages}
            message={message}
            deleteMessage={deleteMessage}
            timeoutDeleteMessage={timeoutDeleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
            setShowModChat={setShowModChat}
            handleInputChange={handleInputChange}
            maxLength={maxLength}
            filterText={filterText}
            setFilterText={setFilterText}
            setShowReportUser={setShowReportUser}
            setReportedUser={setReportedUser}
            setShowBanUser={setShowBanUser}
            setBannedUser={setBannedUser}
            moderators={moderators}
            moderate={moderate}
            deleteModerator={deleteModerator}
            TimeOut={TimeOut}
            banDeleteMessage={banDeleteMessage}
            Ban={Ban}
            viewerCount={viewerCount}
            setMessage={setMessage}
            gifMode={gifMode}
          />
        )}
      </div>
    </Fragment>
  );
};

Landing.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  modChatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
  deleteModChatMessage: PropTypes.func.isRequired,
  getModerators: PropTypes.func.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  moderate: PropTypes.func.isRequired,
  deleteModerator: PropTypes.func.isRequired,
  timeoutUser: PropTypes.func.isRequired,
  unTimeoutUser: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
  getSupporters: PropTypes.func.isRequired,
  addSupporter: PropTypes.func.isRequired,
  banUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  stream: state.stream,
  message: state.message,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  login,
  logout,
  getProfileById,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getModerators,
  getActiveUsers,
  moderate,
  banUser,
  deleteModerator,
  timeoutUser,
  unTimeoutUser,
  getGifs,
  getGifsSearch,
  getSupporters,
  addSupporter,
  clearMsg,
})(Landing);
